import React from "react";
import { Navigate } from "react-router-dom";
import { usePublicPages } from "../../contexts/PublicPagesContext";

/**
 * Route guard that redirects to "/" when the given page feature flag is off.
 * While the settings are still loading, all pages are treated as enabled
 * (fail-open) to avoid a flash-redirect on initial load.
 *
 * Usage in AppRoutes.js:
 *   <RequirePublicPage pageKey="marketplace">
 *     <MarketplacePage />
 *   </RequirePublicPage>
 */
const RequirePublicPage = ({ pageKey, children }) => {
  const { isPageEnabled, loading } = usePublicPages();

  // Fail-open while settings load
  if (loading) return children;

  if (!isPageEnabled(pageKey)) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default RequirePublicPage;
